import { NestedCSSProperties } from 'typestyle/lib/types';
import { media } from 'typestyle';
import {constantTabletBreakpoint, constantMobileBreakpoint, constantDesktopBreakpoint} from './constant';

export const mediaMobileOnly: (styles: NestedCSSProperties) => NestedCSSProperties =
  (styles: NestedCSSProperties) => media({ maxWidth: constantMobileBreakpoint }, styles);

export const mediaTabletLandscape: (styles: NestedCSSProperties) => NestedCSSProperties =
  (styles: NestedCSSProperties) => media({ minWidth: constantMobileBreakpoint, maxHeight: 720, maxWidth: constantDesktopBreakpoint, orientation: 'landscape' }, styles);

export const mediaTablet: (styles: NestedCSSProperties) => NestedCSSProperties =
  (styles: NestedCSSProperties) => media({ minWidth: constantTabletBreakpoint }, styles);

export const mediaTabletOnly: (styles: NestedCSSProperties) => NestedCSSProperties =
  (styles: NestedCSSProperties) => media({ maxWidth: constantDesktopBreakpoint - 1 }, styles);

export const mediaDesktop: (styles: NestedCSSProperties) => NestedCSSProperties =
  (styles: NestedCSSProperties) => media({ minWidth: constantDesktopBreakpoint }, styles);

